import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { GetSessionStorageData } from "../../Utilities/Helpers/Helper";
import { AUTHENTICATION, FILTER_CONSTANT } from "../../Constants/Constants";

export interface LanguageState {
  language: string;
  jsonDataEnglish: any;
  jsonDataArabic: any;
}


export interface GoogleMapLoaded {
  isGoogleMapLoaded: boolean;
}

export interface LoaderState {
  loader: boolean;
}

/**Login sign up model */
export interface LoginSignUpDialog {
  open: boolean;
}

/**Login sign up model */
export interface guestSignupDialog {
  open: boolean;
}
export interface Location {
  lat: number;
  lng: number;
}
export interface LocationProps {
  location: Location | null;
}

export interface S3Props {
  datakey: any;
}

export interface LocationNameProps {
  locationName: string;
}

export interface LocationRadiusProps {
  locationRadius: any;
}

const initialStateLocation: LocationProps = {
  location: null,
};


export interface NotificationRefesh {
  notificationRefresh: any;
}

export interface FilterState {
  tutorfilter: any;
  universityfilter: any;
  schoolfilter: any;
  activityfilter: any;
}

export interface InitfilterState {
  initTutorfilter: any;
  initUniversityfilter: any;
  initSchoolfilter: any;
  initActivityfilter: any;
}

export interface TermsandConditionsState {
  check: boolean;
}
export interface ErrorNotificationState {
  check: boolean,
  errormessage: any
}
/**Language state */
const value = GetSessionStorageData(AUTHENTICATION.SHARED.LANGUAGE_SWICTH);
const initialState: LanguageState = {
  language: value ?? "English",
  jsonDataEnglish: {},
  jsonDataArabic: {},
};

const initialGoogleMapLoaded: GoogleMapLoaded = {
  isGoogleMapLoaded: false
}


const initialStateS3Key: S3Props = {
  datakey: {},
};

/**location Name state */
const initialLocationName: LocationNameProps = {
  locationName: '',
};

/**location Radius state */
const initialLocationRadius: LocationRadiusProps = {
  locationRadius: '',
};

/**Loader State */
const initialLoaderState: LoaderState = {
  loader: false,
};

/**Login signUp dialog */
const loginSignUpDialogState: LoginSignUpDialog = {
  open: false,
};

/**Login signUp dialog */
const guestSignupDialogState: guestSignupDialog = {
  open: false,
};

/**Notification Refresh state */
const initialNotification: NotificationRefesh = {
  notificationRefresh: '',
};


const tutor_filter: any = GetSessionStorageData(FILTER_CONSTANT.STATE_FILTER.TUTOR);
const school_filter: any = GetSessionStorageData(FILTER_CONSTANT.STATE_FILTER.SCHOOL);
const university_filter: any = GetSessionStorageData(FILTER_CONSTANT.STATE_FILTER.UNIVERSITY);
const activity_filter: any = GetSessionStorageData(FILTER_CONSTANT.STATE_FILTER.ACTIVITY);


const initialFilter: FilterState = {
  tutorfilter: JSON.parse(tutor_filter) ?? {},
  universityfilter: JSON.parse(university_filter) ?? {},
  schoolfilter: JSON.parse(school_filter) ?? {},
  activityfilter: JSON.parse(activity_filter) ?? {}

}


const tutor_init: any = GetSessionStorageData(FILTER_CONSTANT.INIT_FILTER.TUTOR);
const school_init: any = GetSessionStorageData(FILTER_CONSTANT.INIT_FILTER.SCHOOL);
const university_init: any = GetSessionStorageData(FILTER_CONSTANT.INIT_FILTER.UNIVERSITY);
const activity_init: any = GetSessionStorageData(FILTER_CONSTANT.INIT_FILTER.ACTIVITY);


const InitFilterState: InitfilterState = {
  initTutorfilter: JSON.parse(tutor_init) ?? {},
  initUniversityfilter: JSON.parse(university_init) ?? {},
  initSchoolfilter: JSON.parse(school_init) ?? {},
  initActivityfilter: JSON.parse(activity_init) ?? {},
}


const InitailTermsandConditionsState: TermsandConditionsState = {
  check: false
}

const IntialErrorNotificationState: ErrorNotificationState = {
  check: false,
  errormessage: ''
}
export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state: any, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    getLanguageJsonEnglish: (state: any, action: PayloadAction<string>) => {
      state.jsonDataEnglish = action.payload;
    },
    getLanguageJsonArabic: (state: any, action: PayloadAction<string>) => {
      state.jsonDataArabic = action.payload;
    },
  },
});

export const googleMapLoadedSlice = createSlice({
  name: "googleMapLoaded",
  initialState: initialGoogleMapLoaded,
  reducers: {
    setGoogleMapLoaded: (state: any, action: PayloadAction<boolean>) => {
      state.isGoogleMapLoaded = action.payload;
    }
  }
})

export const locationSlice = createSlice({
  name: "location",
  initialState: initialStateLocation,
  reducers: {
    setLocation: (state, action: PayloadAction<Location>) => {
      state.location = action.payload;
    },
  },
})

/**Update s3 data key */
export const s3DataKeySlice = createSlice({
  name: "datakey",
  initialState: initialStateS3Key,
  reducers: {
    setS3DataKey: (state: any, action: any) => {
      state.datakey = action.payload;
    },
  },
});

/**Update locationName */
export const locationNameSlice = createSlice({
  name: "locationName",
  initialState: initialLocationName,
  reducers: {
    setLocationName: (state: any, action: PayloadAction<string>) => {
      state.locationName = action.payload;
    },
  },
});

/**Update locationRadius */
export const locationRadiusSlice = createSlice({
  name: "locationRadius",
  initialState: initialLocationRadius,
  reducers: {
    setLocationRadius: (state: any, action: any) => {
      state.locationRadius = action.payload;
    },
  },
});

/**Update Notification Refrsh */
export const notificationRereshSlice = createSlice({
  name: "notificationRefresh",
  initialState: initialNotification,
  reducers: {
    setNotificationRefresh: (state: any, action: any) => {
      state.notificationRefresh = action.payload;
    },
  },
});

/**Update loader */
export const loaderSlice = createSlice({
  name: "loader",
  initialState: initialLoaderState,
  reducers: {
    setLoader: (state: any, action: PayloadAction<boolean>) => {
      state.loader = action.payload;
    },
  },
});

/**Login Sign Up dialog */
export const LoginSignUpSlice = createSlice({
  name: "loginSignUp",
  initialState: loginSignUpDialogState,
  reducers: {
    setLoginSignUpOpen: (state: any, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
});

/**Guest User Sign Up dialog */
export const GuestSignupSlice = createSlice({
  name: "guestSignUp",
  initialState: guestSignupDialogState,
  reducers: {
    setGuestSignupOpen: (state: any, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
});

/**Login Sign Up dialog */
export const ChildLoginRestrictionSlice = createSlice({
  name: "childLoginRestriction",
  initialState: loginSignUpDialogState,
  reducers: {
    setChildLoginRestriction: (state: any, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
});


export const FilterSlice = createSlice({
  name: "filter",
  initialState: initialFilter,
  reducers: {
    setTutorFilter: (state: any, action: PayloadAction<any>) => {
      state.tutorfilter = action.payload;
    },
    setSchoolFilter: (state: any, action: PayloadAction<any>) => {
      state.schoolfilter = action.payload;
    },
    setUniversityFilter: (state: any, action: PayloadAction<any>) => {
      state.universityfilter = action.payload;
    },
    setActivitiesFilter: (state: any, action: PayloadAction<any>) => {
      state.activityfilter = action.payload;
    }
  }
})


export const InitFilterSlice = createSlice({
  name: "initFilter ",
  initialState: InitFilterState,
  reducers: {
    setInitTutorFilter: (state: any, action: PayloadAction<any>) => {
      state.initTutorfilter = action.payload;
    },
    setInitSchoolFilter: (state: any, action: PayloadAction<any>) => {
      state.initSchoolfilter = action.payload;
    },
    setInitUniversityFilter: (state: any, action: PayloadAction<any>) => {
      state.initUniversityfilter = action.payload;
    },
    setInitActivitiesFilter: (state: any, action: PayloadAction<any>) => {
      state.initActivityfilter = action.payload;
    }
  }
})

export const TermsandConditionsSlice = createSlice({
  name: "TermsandConditions",
  initialState: InitailTermsandConditionsState,
  reducers: {
    setTermsandConditions: (state: any, action: PayloadAction<boolean>) => {
      state.TermsandConditions = action.payload;
    }
  }
})

export const ErrorNotificationSlice = createSlice({
  name: "ErrorNotification",
  initialState: IntialErrorNotificationState,
  reducers: {
    setErrorNotification: (state: any, action: PayloadAction<boolean>) => {
      state.check = action.payload
    },
    setErrorMessage: (state: any, action: PayloadAction<string>) => {
      state.errormessage = action.payload
    }
  },
})





export const locationRadiusReducer = locationRadiusSlice.reducer;
export const { setLocationRadius } = locationRadiusSlice.actions;

export const notificationRefreshReducer = notificationRereshSlice.reducer;
export const { setNotificationRefresh } = notificationRereshSlice.actions;

export const s3DataKeyReducer = s3DataKeySlice.reducer;
export const { setS3DataKey } = s3DataKeySlice.actions;

export const locationNameReducer = locationNameSlice.reducer;
export const { setLocationName } = locationNameSlice.actions;

export const locationReducer = locationSlice.reducer;
export const { setLocation } = locationSlice.actions;

export const languageReducer = languageSlice.reducer;
export const { setLanguage, getLanguageJsonEnglish, getLanguageJsonArabic } = languageSlice.actions;

export const loaderReducer = loaderSlice.reducer;
export const { setLoader } = loaderSlice.actions;

export const loginSignUpReducer = LoginSignUpSlice.reducer;
export const { setLoginSignUpOpen } = LoginSignUpSlice.actions;

export const guestSignupReducer = GuestSignupSlice.reducer;
export const { setGuestSignupOpen } = GuestSignupSlice.actions;

export const childLoginRestrictionReducer = ChildLoginRestrictionSlice.reducer;
export const { setChildLoginRestriction } = ChildLoginRestrictionSlice.actions;

export const filterReducer = FilterSlice.reducer;
export const { setTutorFilter, setActivitiesFilter, setSchoolFilter, setUniversityFilter } = FilterSlice.actions;

export const initFilterReducer = InitFilterSlice.reducer;
export const { setInitTutorFilter, setInitActivitiesFilter, setInitSchoolFilter, setInitUniversityFilter } = InitFilterSlice.actions;

export const TermsandConditionsReducer = TermsandConditionsSlice.reducer;
export const { setTermsandConditions } = TermsandConditionsSlice.actions;

export const ErrorNotificationReducer = ErrorNotificationSlice.reducer;
export const { setErrorNotification, setErrorMessage } = ErrorNotificationSlice.actions;

export const googleMapLoadedReducer = googleMapLoadedSlice.reducer;
export const { setGoogleMapLoaded } = googleMapLoadedSlice.actions;

